<template>
  <div class="social-icons">
    <a
      v-if="$variable('social.facebookLink')"
      class="social-icons__icon"
      :href="$variable('social.facebookLink')"
      @click="socialIconDataLayer('facebook')"
    >
      <span
        class="visually-hidden"
        v-text="$string('accessibility.social_icons.facebook')"
      />
      <icon-facebook />
    </a>

    <a
      v-if="$variable('social.instagramLink')"
      class="social-icons__icon"
      :href="$variable('social.instagramLink')"
      @click="socialIconDataLayer('instagram')"
    >
      <span
        class="visually-hidden"
        v-text="$string('accessibility.social_icons.instagram')"
      />
      <icon-instagram />
    </a>

    <a
      v-if="$variable('social.twitterLink')"
      class="social-icons__icon"
      :href="$variable('social.twitterLink')"
      @click="socialIconDataLayer('twitter')"
    >
      <span
        class="visually-hidden"
        v-text="$string('accessibility.social_icons.twitter')"
      />
      <icon-twitter />
    </a>

    <a
      v-if="$variable('social.youtubeLink')"
      class="social-icons__icon"
      :href="$variable('social.youtubeLink')"
      @click="socialIconDataLayer('youtube')"
    >
      <span
        class="visually-hidden"
        v-text="$string('accessibility.social_icons.youtube')"
      />
      <icon-youtube />
    </a>
    <a
      v-if="$variable('social.tiktokLink')"
      class="social-icons__icon"
      :href="$variable('social.tiktokLink')"
      @click="socialIconDataLayer('tiktok')"
    >
      <span
        class="visually-hidden"
        v-text="$string('accessibility.social_icons.tiktok')"
      />
      <icon-tiktok />
    </a>
  </div>
</template>

<script>

/**
 * Vue: Social icons (social-icons)
 * -----------------------------------------------------------------------------
 * Social Media Icons to be used across the site and controlled within the theme settings.
 *
 */
import IconFacebook from '~icons/social/facebook.svg'
import IconInstagram from '~icons/social/instagram.svg'
import IconTwitter from '~icons/social/twitter.svg'
import IconYoutube from '~icons/social/youtube.svg'
import IconTiktok from '~icons/social/tiktok.svg'
export default {
  name: 'SocialIcons',

  components: {
    IconFacebook,
    IconInstagram,
    IconTwitter,
    IconYoutube,
    IconTiktok,
  },

  data() {
    return {
    }
  },

  mounted() {
    // Not empty
  },

  methods: {

    /**
     * Send the click event info to the data layer.
     * @param {String} label - clicked icon text.
     */
    socialIconDataLayer(label) {
      cnvs.EventBus.emit('Datalayer:socialIcon', label)
    },

  },
}
</script>

<style lang="scss">
@import './social-icons';
</style>

